import {
    ChangeDetectionStrategy,
    Component,
    input,
} from '@angular/core';

import { MediaRatioSkeleton } from '../../models/media.models';

import { Position } from '@shared/product/models';

@Component({
    selector: 'media-skeleton',
    templateUrl: './media-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class MediaSkeletonComponent {
    public position = Position;

    public ratio = input<MediaRatioSkeleton>();

    public holygrail2 = input<boolean>(true);

    public skeletonTextPosition = input<string>();
}
